import '../css/App.css';
import React, { useState, useRef, useEffect}from'react';
import { useNavigate } from 'react-router-dom'
import reportUtils from '../utilities/report/reportutils';
import PathDisplayBlock from '../components/reportPage/recommendations/pathsdisplayblocks.js';
import Investigations from '../components/reportPage/investigations/investigations.js';
import { Grid, Typography, Button, Alert, Box } from  '@mui/material';
import SymptomBox from '../components/reportPage/symptoms/symptomBox';
import { SymptomDetailsContext } from '../utilities/context.js'
import buildOutcomeObject from '../utilities/report/buildoutcomeobject';
import ExceptionalFormQuestionsModal from '../components/reportPage/recommendations/exceptionalrdcpath/exceptionalFormQuestionsModal';


function Report(props)
{
 const [extraSymptomDetails, setExtraSymptomDetails] = useState([]) 
 const [story,setStory] = useState()
 const [ixList, setIxList] = useState()
 const [rdc, setRdc] =useState([])
 const [nonRdc,setNonRdc] =useState([])
 const [genericQuestionsAsked, setGenericQuestionsAsked]= useState(false)
 const [ clinicQuestions, setClinicQuestions] = useState({rdc:{},nonRdc:{}})
 const [investigationQuestions, setInvestigationQuestions] = useState()
 const [ exceptionalRefDetails,setExeptionalRefDetails] = useState([])
 const [formData, setFormData]=useState((props.formData))
 const [alertIX, setAlertIx] = useState(false)
 const [alertStory, setAlertStory]= useState(false)
 const modifiedFormData=useRef()
 const [exceptionalFormQuestionsModalOpen, setExceptionalQuestionsModalOpen] = useState(false)
 const navigate = useNavigate();


 modifiedFormData.current=reportUtils.ValidateTwr(formData)

  let pathBlocks=modifiedFormData.current.sortedPaths.map((eachPath,index)=><PathDisplayBlock eachPath={eachPath} modifiedFormData={modifiedFormData.current} key={index}/>)

let investigationBlock=<Investigations formData={formData}/>

const removeIxalert=()=>
  {
  setAlertIx(false)
  if (!alertStory)
    {showOutcome()}
  }

const removeStoryAlert=()=>
  {
  setAlertStory(false)
  if (!alertIX)
    {showOutcome()}
  }

const veryfyComplete =()=> 
  {  let proceed = true
  if (formData.investigations.length > 0 && ixList === undefined)
    {
      setAlertIx(true)
      proceed = false
    } 
    
  if (story === undefined || story === "")
      {
      setAlertStory(true)
      proceed = false
      }
      if (proceed)
        {showOutcome()}
    }

  const showOutcome=()=>
    {
  let outcome = buildOutcomeObject(clinicQuestions, formData, extraSymptomDetails, story, ixList, rdc, nonRdc, investigationQuestions,exceptionalRefDetails)
  props.setOutcomeData(outcome)
  navigate('../Outcome')
    }

    const openExceptionalQuestions=()=>{setExceptionalQuestionsModalOpen(true)}
  
   useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
    
   return(
     <SymptomDetailsContext.Provider value = {{ 
      extraSymptomDetails, setExtraSymptomDetails,
      story, setStory, 
      ixList,setIxList, 
      rdc, setRdc, 
      nonRdc, setNonRdc,
      genericQuestionsAsked, setGenericQuestionsAsked,
      clinicQuestions, setClinicQuestions,
      investigationQuestions,setInvestigationQuestions,
      exceptionalRefDetails,setExeptionalRefDetails }}>
   
   <Grid container >
   
    <Grid item alignSelf="auto" height="fit-content" position="relative" xs={12} sm={12} md={9} key={props.key} sx={{borderRight:"black solid"}} >

   <Grid container >
    <Grid item xs={12} sm={12} md={12}>
       <Typography variant='h4' align="center" sx={{ p:1 }}>  NICE Recommendations</Typography>
       </Grid>
     {pathBlocks}
     <Box className='pathDisplayBlocktwr'>
      <Typography variant='h6'> Exceptional referral</Typography>
      <Typography variant='body1'>If you recieved an investigation or lab results suggestive of a cancer on RDC path not offered above or have a very strong clinical suspicion of cancer on an pathway which hasn't been offered you can make a referral here.  </Typography>
     <Button variant='contained'  onClick={openExceptionalQuestions}> Make an RDC referral not covered by NG12 Guidance. </Button>
     </Box>
    <ExceptionalFormQuestionsModal modalOpen={exceptionalFormQuestionsModalOpen} setModalOpen={setExceptionalQuestionsModalOpen} />
   </Grid>
   </Grid>
   <Grid item  xs={12} sm={12} md={3}>
   <Grid container> 
   <Grid item xs={12} sm={12} md={12}sx={{borderBottom:"black solid"}} >

   <Typography variant="h4" sx={{ p:1 }}> Symptoms </Typography>
  <SymptomBox formData={props.formData} melanomaSevenPoint={props.melanomaSevenPoint} idaValues={props.idaValues}/>
  </Grid>
   <Grid item xs={12} sm={12} md={12}>
    <Typography variant='h4'  sx={{ p:1 }}> Recommended Investigations</Typography>
  
     {investigationBlock}
  </Grid>
  </Grid>
</Grid>
<Grid>
  {alertIX && <Alert severity='warning'> You have not requested any investigations <Button variant='outlined' onClick={removeIxalert}>Ignore warning</Button></Alert>}

  {alertStory && <Alert severity='warning'> You have not entered any clinical history <Button variant='outlined' onClick={removeStoryAlert}>Ignore warning</Button></Alert>}

<Button size='large' variant='contained' onClick={veryfyComplete}> Finished</Button>

</Grid>
  </Grid>
  </SymptomDetailsContext.Provider>
)
}

export default Report
